/***************************************** INITIAL STATE ********************************************/
import { updateConfig } from '../../configs/config'
import AssignmentService from '../../services/assignment.service'
import AuthService from '../../services/auth.service'
import InstantFeedbackService from '../../services/instant-feedback.service'
import LocalStorageService from '../../services/local-storage.service'
import { handleErrors } from '../../utils/request.helper'

export const INITIAL_STATE = {
    code: '',
    starterCode: '',
    submitted: false,
    studentToken: null,
    assignmentName: '',
    assignmentType: '',
    language: '',
    unitTests: [],
    components: [],
    isWaitingForCheckStudent: false,
    isWaitingForResults: false,
    isWaitingForUnitTests: false,
    totalGrade: 0,
    hideGrading: false,
    unitTestsAvailable: false,
    lastSubmittedCode: '',
    infoSection: {
        instructions: '',
        output: '',
        activeTabKey: 'instructions',
    },
    showInstructionsModal: false,
    showRetrieveStarterCodeModal: false,
    hasNaturalLanguagePatterns: false,
    unitTestsTipsEnabled: false,
}

/***************************************** ACTION TYPES *********************************************/
const reducerName = 'INSTANT_FEEDBACK_'
const actionTypes = {
    SET_CODE: `${reducerName}SET_CODE`,
    SET_STARTER_CODE: `${reducerName}SET_STARTER_CODE`,
    SET_SUBMITTED: `${reducerName}SET_SUBMITTED`,
    SET_STUDENT_TOKEN: `${reducerName}SET_STUDENT_TOKEN`,
    SET_ASSIGNMENT_NAME: `${reducerName}SET_ASSIGNMENT_NAME`,
    SET_ASSIGNMENT_TYPE: `${reducerName}SET_ASSIGNMENT_TYPE`,
    SET_LANGUAGE: `${reducerName}SET_LANGUAGE`,
    SET_UNIT_TESTS: `${reducerName}SET_UNIT_TESTS`,
    SET_COMPONENTS: `${reducerName}SET_COMPONENTS`,
    SET_IS_WAITING_FOR_CHECK_STUDENT: `${reducerName}SET_IS_WAITING_FOR_CHECK_STUDENT`,
    SET_IS_WAITING_FOR_RESULTS: `${reducerName}SET_IS_WAITING_FOR_RESULTS`,
    SET_IS_WAITING_FOR_UNIT_TESTS: `${reducerName}SET_IS_WAITING_FOR_UNIT_TESTS`,
    SET_TOTAL_GRADE: `${reducerName}SET_TOTAL_GRADE`,
    SET_HIDE_GRADING: `${reducerName}SET_HIDE_GRADING`,
    SET_UNIT_TESTS_AVAILABLE: `${reducerName}SET_UNIT_TESTS_AVAILABLE`,
    UPDATE_UT_GRADE: `${reducerName}UPDATE_UT_GRADE`,
    SET_INSTRUCTIONS: `${reducerName}SET_INSTRUCTIONS`,
    SET_ACTIVE_TAB_KEY: `${reducerName}SET_ACTIVE_TAB_KEY`,
    SET_OUTPUT: `${reducerName}SET_OUTPUT`,
    SET_SHOW_INSTRUCTIONS_MODAL: `${reducerName}SET_SHOW_INSTRUCTIONS_MODAL`,
    SET_SHOW_RETRIEVE_STARTER_CODE_MODAL: `${reducerName}SET_SHOW_RETRIEVE_STARTER_CODE_MODAL`,
    SET_HAS_NATURAL_LANGUAGE_PATTERNS: `${reducerName}SET_HAS_NATURAL_LANGUAGE_PATTERNS`,
    RESET_ASSIGNMENT: `${reducerName}RESET_ASSIGNMENT`,
    RESET_ASSIGNMENT_FOR_EDIT: `${reducerName}RESET_ASSIGNMENT_FOR_EDIT`,
    SET_LINTER_CONFIG: `${reducerName}SET_LINTER_CONFIG`,
    SET_UNIT_TESTS_TIPS_ENABLED: `${reducerName}SET_UNIT_TESTS_TIPS_ENABLED`,
    SET_LAST_SUBMITTED_CODE: 'SET_LAST_SUBMITTED_CODE',
}

/******************************************** ACTIONS ***********************************************/
export const actions = {
    setSubmitted: value => ({
        type: actionTypes.SET_SUBMITTED,
        payload: { value },
    }),
    setLinterConfig: value => ({
        type: actionTypes.SET_LINTER_CONFIG,
        payload: { value },
    }),
    setCode: value => ({
        type: actionTypes.SET_CODE,
        payload: { value },
    }),
    setStarterCode: value => ({
        type: actionTypes.SET_STARTER_CODE,
        payload: { value },
    }),
    setStudentToken: value => ({
        type: actionTypes.SET_STUDENT_TOKEN,
        payload: { value },
    }),
    setAssignmentName: value => ({
        type: actionTypes.SET_ASSIGNMENT_NAME,
        payload: { value },
    }),
    setAssignmentType: value => ({
        type: actionTypes.SET_ASSIGNMENT_TYPE,
        payload: { value },
    }),
    setLanguage: value => ({
        type: actionTypes.SET_LANGUAGE,
        payload: { value },
    }),
    setUnitTests: value => ({
        type: actionTypes.SET_UNIT_TESTS,
        payload: { value },
    }),
    setComponents: values => ({
        type: actionTypes.SET_COMPONENTS,
        payload: { values },
    }),
    setIsWaitingForCheckStudent: value => ({
        type: actionTypes.SET_IS_WAITING_FOR_CHECK_STUDENT,
        payload: { value },
    }),
    setIsWaitingForResults: value => ({
        type: actionTypes.SET_IS_WAITING_FOR_RESULTS,
        payload: { value },
    }),
    setIsWaitingForUnitTests: value => ({
        type: actionTypes.SET_IS_WAITING_FOR_UNIT_TESTS,
        payload: { value },
    }),
    setTotalGrade: value => ({
        type: actionTypes.SET_TOTAL_GRADE,
        payload: { value },
    }),
    setHideGrading: value => ({
        type: actionTypes.SET_HIDE_GRADING,
        payload: { value },
    }),
    setUnitTestsAvailable: value => ({
        type: actionTypes.SET_UNIT_TESTS_AVAILABLE,
        payload: { value },
    }),
    updateUTGrade: value => ({
        type: actionTypes.UPDATE_UT_GRADE,
        payload: { value },
    }),
    setInstructions: value => ({
        type: actionTypes.SET_INSTRUCTIONS,
        payload: { value },
    }),
    setOutput: value => ({
        type: actionTypes.SET_OUTPUT,
        payload: { value },
    }),
    setShowInstructionsModal: value => ({
        type: actionTypes.SET_SHOW_INSTRUCTIONS_MODAL,
        payload: { value },
    }),
    setShowRetrieveStarterCodeModal: value => ({
        type: actionTypes.SET_SHOW_RETRIEVE_STARTER_CODE_MODAL,
        payload: { value },
    }),
    setHasNaturalLanguagePatterns: value => ({
        type: actionTypes.SET_HAS_NATURAL_LANGUAGE_PATTERNS,
        payload: { value },
    }),
    setActiveTabKey: value => ({
        type: actionTypes.SET_ACTIVE_TAB_KEY,
        payload: { value },
    }),
    setUnitTestsTipsEnabled: value => ({
        type: actionTypes.SET_UNIT_TESTS_TIPS_ENABLED,
        payload: { value },
    }),
    resetAssignmentForEdit: () => ({
        type: actionTypes.RESET_ASSIGNMENT_FOR_EDIT,
    }),
    resetAssignment: () => ({
        type: actionTypes.RESET_ASSIGNMENT,
    }),
    createAssignmentStudentFeedback: (token, userId, liked) => async (dispatch, getState) => {
        return await handleErrors(async () => {
            const studentId =
                userId || getState().instantFeedback.studentToken || LocalStorageService.getAnonFeedbackId()

            const createAssignmentStudentFeedbackResponse =
                await InstantFeedbackService.createAssignmentStudentFeedback(token, studentId, liked)
            return createAssignmentStudentFeedbackResponse.data.id
        })
    },
    updateAssignmentStudentFeedback: (id, feedback) => async () => {
        return await handleErrors(async () => {
            await InstantFeedbackService.updateAssignmentStudentFeedback(id, feedback)
        })
    },
    fetchLinterConfig: token => async dispatch => {
        return await handleErrors(async () => {
            const { data } = await AssignmentService.getLinterConfig(token)

            dispatch(actions.setLinterConfig(data))
        })
    },
    fetchLanguageServerToken: () => async () => {
        const languageServerToken = await handleErrors(async () => {
            const response = await AuthService.getLanguageServerToken()
            return response.data
        })

        if (languageServerToken) {
            updateConfig({ languageServerToken })
        }

        return languageServerToken
    },
    setLastSubmittedCode: value => ({
        type: actionTypes.SET_LAST_SUBMITTED_CODE,
        payload: { value },
    }),
}

/******************************************* REDUCER ************************************************/
const instantFeedbackReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SET_CODE:
            return {
                ...state,
                code: action.payload.value,
            }

        case actionTypes.SET_STARTER_CODE:
            return {
                ...state,
                starterCode: action.payload.value,
            }

        case actionTypes.SET_SUBMITTED:
            return {
                ...state,
                submitted: action.payload.value,
            }

        case actionTypes.SET_STUDENT_TOKEN:
            return {
                ...state,
                studentToken: action.payload.value,
            }

        case actionTypes.SET_ASSIGNMENT_NAME:
            return {
                ...state,
                assignmentName: action.payload.value,
            }

        case actionTypes.SET_ASSIGNMENT_TYPE:
            return {
                ...state,
                assignmentType: action.payload.value,
            }

        case actionTypes.SET_LANGUAGE:
            return {
                ...state,
                language: action.payload.value,
            }

        case actionTypes.SET_UNIT_TESTS:
            return {
                ...state,
                unitTests: action.payload.value,
            }

        case actionTypes.SET_COMPONENTS:
            return {
                ...state,
                components: action.payload.values,
            }

        case actionTypes.SET_IS_WAITING_FOR_CHECK_STUDENT:
            return {
                ...state,
                isWaitingForCheckStudent: action.payload.value,
            }

        case actionTypes.SET_IS_WAITING_FOR_RESULTS:
            return {
                ...state,
                isWaitingForResults: action.payload.value,
            }

        case actionTypes.SET_IS_WAITING_FOR_UNIT_TESTS:
            return {
                ...state,
                isWaitingForUnitTests: action.payload.value,
            }

        case actionTypes.SET_TOTAL_GRADE:
            return {
                ...state,
                totalGrade: action.payload.value,
            }

        case actionTypes.SET_HIDE_GRADING:
            return {
                ...state,
                hideGrading: action.payload.value,
            }

        case actionTypes.SET_UNIT_TESTS_AVAILABLE:
            return {
                ...state,
                unitTestsAvailable: action.payload.value,
            }

        case actionTypes.SET_INSTRUCTIONS:
            return {
                ...state,
                infoSection: {
                    ...state.infoSection,
                    instructions: action.payload.value,
                },
            }

        case actionTypes.SET_OUTPUT:
            return {
                ...state,
                infoSection: {
                    ...state.infoSection,
                    output: action.payload.value,
                },
            }

        case actionTypes.SET_SHOW_INSTRUCTIONS_MODAL:
            return {
                ...state,
                showInstructionsModal: action.payload.value,
            }

        case actionTypes.SET_SHOW_RETRIEVE_STARTER_CODE_MODAL:
            return {
                ...state,
                showRetrieveStarterCodeModal: action.payload.value,
            }

        case actionTypes.SET_HAS_NATURAL_LANGUAGE_PATTERNS:
            return {
                ...state,
                hasNaturalLanguagePatterns: action.payload.value,
            }

        case actionTypes.SET_ACTIVE_TAB_KEY:
            return {
                ...state,
                infoSection: {
                    ...state.infoSection,
                    activeTabKey: action.payload.value,
                },
            }

        case actionTypes.UPDATE_UT_GRADE:
            return {
                ...state,
                components: state.components.map(component => {
                    return component.layer_name.toLowerCase() === 'unit tests'
                        ? {
                              ...component,
                              cluster_fdbk: {
                                  ...component.cluster_fdbk,
                                  grade: action.payload.value,
                              },
                          }
                        : component
                }),
            }

        case actionTypes.RESET_ASSIGNMENT_FOR_EDIT:
            return {
                ...state,
                submitted: false,
                components: [],
                totalGrade: 0,
                isWaitingForResults: false,
                infoSection: {
                    ...state.infoSection,
                    output: '',
                },
            }

        case actionTypes.RESET_ASSIGNMENT:
            return {
                ...state,
                code: '',
                submitted: false,
                components: [],
                unitTests: [],
                isWaitingForResults: false,
                totalGrade: 0,
            }

        case actionTypes.SET_LINTER_CONFIG:
            return {
                ...state,
                linterConfig: action.payload.value,
            }

        case actionTypes.SET_UNIT_TESTS_TIPS_ENABLED:
            return {
                ...state,
                unitTestsTipsEnabled: action.payload.value,
            }

        case actionTypes.SET_LAST_SUBMITTED_CODE:
            return {
                ...state,
                lastSubmittedCode: action.payload.value,
            }

        default:
            return state
    }
}

export default instantFeedbackReducer
